import { OOM_REVIEW_ALLOWED_USER_IDS } from '@/constants';

export type ActionIcon = 'calendar' | 'medical';

export interface ActionDefinition {
  id: string;
  title: string;
  description: string;
  /** Header of the action's modal. Deliberately worded differently from the tile's `title`. */
  modalTitle: string;
  /** Sub-heading under `modalTitle`. Deliberately worded differently from the tile's `description`. */
  modalDescription: string;
  /** Fuller explanation surfaced as a tooltip and the tile's accessible name. */
  tooltip: string;
  category: string;
  icon: ActionIcon;
  accessLevel: 'all' | 'restricted';
  /** Additional user IDs (beyond ACTIONS_ALLOWED_USER_IDS) who can see this specific action. */
  allowedUserIds?: string[];
  successMessage: string;
}

export const ACTIONS_REGISTRY: ActionDefinition[] = [
  {
    id: 'cp1',
    title: 'AI CP1s',
    description: 'AI-generate CP1 documents',
    modalTitle: 'AI-Generated CP1s',
    modalDescription: 'Generate CP1 documents',
    tooltip: 'Generate CP1 documents for the case references you provide. Results appear in Proclaim.',
    category: 'Case Documents',
    icon: 'calendar',
    accessLevel: 'restricted',
    successMessage: 'AI CP1 request sent. AI CP1s should appear in Proclaim shortly.',
  },
  {
    id: 'oom-review',
    title: 'AI OOM Overturns',
    description: 'AI-generate challenge to nursing Opinions on Merit',
    modalTitle: 'AI-Generated OOM Overturns',
    modalDescription: 'Challenge nursing Opinions on Merit',
    tooltip:
      'Generate challenges to nursing Opinions on Merit for the case references you provide. Results appear in Proclaim.',
    category: 'Case Documents',
    icon: 'medical',
    accessLevel: 'restricted',
    allowedUserIds: OOM_REVIEW_ALLOWED_USER_IDS,
    successMessage: 'AI OOM Overturn request sent. Documents should appear in Proclaim shortly.',
  },
];
